<template>
  <AppTag :background="background" style="color: white; font-weight: bold">
    <span class="p-pr-2" v-if="transaction.categoryId === 1">
      <IconCart fill="white" :width="11" :height="11"></IconCart>
    </span>
    <span class="p-pr-2 p-mt-1" v-if="transaction.categoryId === 2">
      <IconService fill="white" :width="14" :height="14"></IconService>
    </span>
    <span>
      {{ text }}
    </span>
  </AppTag>
</template>

<script>
import IconCart from '../../../components/icon/IconCart.vue';
import IconService from '../../../components/icon/IconService.vue';

export default {
  name: 'CashFlowTypeTag',
  props: {
    transaction: Object,
  },
  components: {
    IconCart,
    IconService,
  },
  computed: {
    text() {
      const typeName = this.transaction.typeId === 1 ? 'Receita' : 'Despesa';
      return `${typeName} #${this.transaction.id}`;
    },
    background() {
      return this.transaction.typeId === 1 ? '#00C52B' : '#FF5757';
    },
  },
};
</script>

<style>
</style>
